import React, { useEffect, useState } from 'react';
import Header from '../components/shared/Header';
import AppointmentDetails from './AppointmentDetails';
import Button from '../components/shared/Button';
import '../styles/global.css';
import DatePickerComponent from './DatePickerComponent';
import PreferredOptometristSelector from './PreferredOptometristSelector';
import { postCreateCustomer } from '../services/postCreateCustomer';
import { useApp } from '../context/appContext'
import toast from 'react-hot-toast';
import { postHoldAppointment } from '../services/postHoldAppointment'
import { getStaff } from '../services/getStaff';
import { fbApiUrl } from "./shared/facebooktrack_config";  
import errorIcon from '../assets/icons/error.svg';
import { getAssetUrl, haversineDistance } from '../utils/lib';
import { patchCancelAppointment } from "../services/patchCancelAppointment"
import { patchConfirmAppointment } from "../services/patchConfirmAppointment"
import { formatDateLong_new } from "../utils/lib"

const steps = [
  { name: 'Select the location', link: 'listing', isActive: true },
  { name: 'Appointment Details', link: 'date-picker', isActive: true },
  { name: 'Confirm Details', isActive: false }
];


const DatePickerScreen = () => {

  
  const [allStaff, setAllStaff] = useState([]);
  const [loading, setLoading] = useState(false); // Add loading state
  const { form, setForm, setCurrentPage } = useApp();
  const [loading_button, setLoading_button] = useState(false);
  const [submissionFailed, setSubmissionFailed] = useState(false);
  const [clickedButton, setClickedButton] = useState(null);
  const [originalBookingTime, setOriginalBookingTime] = useState({
    appointmentDate: null,
    startTimeReadable: null
  });


  // Log whenever form changes (debugging)
  useEffect(() => {
    //console.log("📌 Form changed:", form);
  }, [form]);

    
  const handleForm = async (e, actionType = null) => {
    if(!form.date || !form.testId || !form.time) {
      toast.error("Please select all required fields")
      return
    }

    e.preventDefault();
    setLoading_button(true);
    setClickedButton(actionType || 'SameDateTime'); // Set which button was clicked

    if (!fbApiUrl) {
      console.error("Error: fbApiUrl is not defined!");
    } 
    else {
      try{
     
        const ipResponse = await fetch("https://api64.ipify.org?format=json");
        const ipData = await ipResponse.json();
        const clientIp = ipData.ip; // Extracted IP Address

        // Get User Agent
        const userAgent = navigator.userAgent;
        
        const data = {
          data: [
            {
              event_name: "Date Time Confirm",
              event_time: Math.floor(Date.now() / 1000),
              event_source_url: window.location.href,
              user_data: {
                client_ip_address: clientIp,
                client_user_agent: userAgent,
              },
              action_source: "website",
              custom_data: {
                appointment_date: form.date,
                appointment_time: form.time,
              },
            },
          ],
          test_event_code: "TEST58912",
        };
      
        const response = await fetch(fbApiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
    
        const result = await response.json();
      }
      catch (error) {
        console.error("Error sending data to Facebook API:", error);
      }
    }

 

    if (actionType === 'SameDateTime') {


      if(originalBookingTime.appointmentDate_prev && originalBookingTime.startTimeReadable_prev && originalBookingTime.startTime_prev &&
        originalBookingTime.endTimeReadable_prev && originalBookingTime.endTime_prev){

        setForm((prevForm) => ({
          ...prevForm,
          appointmentId: form.prev_appointmentId,
          date: originalBookingTime.appointmentDate_prev,
          time: {
            ...prevForm.time, // preserve any other properties in time
            startTimeReadable: originalBookingTime.startTimeReadable_prev,
            startTime: originalBookingTime.startTime_prev,
            endTimeReadable: originalBookingTime.endTimeReadable_prev,
            endTime: originalBookingTime.endTime_prev,
            appointmentDate: originalBookingTime.appointmentDate_prev,
          },
        }))
        
      }
        
      
      await new Promise(resolve => setTimeout(resolve, 1000));

      toast.success("Appointment confirmed successfully!");
      setCurrentPage("confirmation")
      setLoading_button(false);

    }
    else{

      setForm((prevForm) => ({
        ...prevForm,
        appointmentId: null,
      }));


      const res1 = await postHoldAppointment(form)
      if(res1?.data) {
        const res2 = res1?.data;

        console.log(res2);
        console.log(res2.Id);
        console.log('appointmentId');

        setForm((prevForm) => ({
          ...prevForm,
          appointmentId: res2.Id
        }));
        
        await new Promise(resolve => setTimeout(resolve, 1000));
        setSubmissionFailed(false);
  
        if ('prev_appointmentId' in form && form?.prev_appointmentId ) {

          console.log(form);
          console.log(form?.prev_appointmentId);
          console.log(form?.appointmentId);


          const cancelRes = await patchCancelAppointment(form?.prev_appointmentId)
  
          if(cancelRes?.status === "Cancelled") {
            const confirmRes = await patchConfirmAppointment(res2.Id, form?.clientId);
            setLoading(false);
  
            if (confirmRes?.status === "Confirmed") {
              toast.success("Appointment confirmed successfully!");
            } else {
              setSubmissionFailed(true);
              // toast.error("Unfortunately the time slot you requested is no longer available. Please choose another.");
            }
            setCurrentPage("confirmation")
          }
          else{
            toast.error('Failed to reschedule appointment')
          }
  
        }
        else{
          setCurrentPage("form")
        }
        setLoading_button(false);
        
      }
      else{
        setLoading_button(false);
        setSubmissionFailed(true);
        // toast.error(res1.message || "Unfortunately the time slot you requested is no longer available. Please choose another.");
  
      }

    }
    


  }


// Compute whether to show "SameDateTime" button
const showSameDateTimeButton = (() => {
  if (!form?.time?.appointmentDate || !form?.time?.startTime) return false;

  const appointmentDate = new Date(form.time.appointmentDate);
  const today = new Date();

  // Reset hours/minutes for date comparison
  appointmentDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const isFutureDate = appointmentDate.getTime() > today.getTime();
  const isToday = appointmentDate.getTime() === today.getTime();

  if (isFutureDate) return true; // Future date → show button

  if (isToday) {
    // Compare times for today
    const now = new Date();
    const [hours, minutes, seconds] = form.time.startTime.split(':'); // "15:40:00.000Z"
    const appointmentTime = new Date();
    appointmentTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

    return now.getTime() < appointmentTime.getTime(); // show if appointment time is not passed
  }

  return false; // Past date → hide
})();


  useEffect(() => {
    if (submissionFailed) {
      // Delay a bit to make sure the element is rendered
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth"
        });
      }, 100); // 100ms delay to ensure rendering
    }
  }, [submissionFailed]);


  
  useEffect(() => {

    if (form?.time?.appointmentDate && form.time.startTimeReadable) {
      setOriginalBookingTime({
        appointmentDate_prev: formatDateLong_new(form.time.appointmentDate),
        startTimeReadable_prev: (form.time.startTimeReadable),
        startTime_prev: (form.time.startTime),
        endTimeReadable_prev: (form.time.endTimeReadable),
        endTime_prev: (form.time.endTime),
        appointmentDate: formatDateLong_new(form.time.appointmentDate),
        startTimeReadable: form.time.startTimeReadable
      });
    }

    if(!form.location) setCurrentPage("map")

    const fetchStaff = async () => {
      const staff = await getStaff(form?.location?.Id)
      setAllStaff(staff)
    }

    fetchStaff()
  }, [form.location, setCurrentPage, form?.testId])

  const handleDatePickerLoading = (isLoading) => {
    setLoading(isLoading); // Set loader state based on DatePickerComponent status
  };

  return (
      <div className="main-container">
        {(loading) && (
          <div style={{position: 'fixed',height: '100%',width: '100%',top:0,background: 'rgba(0,0,0,0.4)',display: 'flex',justifyContent: 'center',alignItems: 'center',zIndex: 9999,}} className="loader-container">
            <div className="loader"></div>
          </div>
        )}
          <Header
            title="Book an Eye Test"
            steps={steps}
            subheading="Appointment Details"
            pageinfo={
              <>
                <div className="change-store-container">
                        {`${form?.location?.PIAB__Street__c}, ${form?.location?.PIAB__City__c} ${form?.location?.PIAB__State__c} ${form?.location?.PIAB__Postal_Code__c}`}
                    <div className="d-flex btn-container">
                        <button className="change-store" onClick={() => setCurrentPage("map")}>Change store
                        </button>
                    </div>
                </div>
              </>
            }
          />
          <AppointmentDetails/>
          <PreferredOptometristSelector staff={allStaff} />
          <DatePickerComponent onLoading={handleDatePickerLoading} />

          {form?.prev_appointmentId ? (
            <>
              <div className="submit-button-container">
                <button className="custom-button datepicker-continue" disabled={loading_button} onClick={(e) => handleForm(e, 'Reschedule')} >
                  {loading_button && clickedButton === 'Reschedule' ? <span className="loader_datepicker_screen"></span> : "Continue to Reschedule"}
                </button>
              </div>
              <div className="submit-button-container">
                <button className="custom-button-new" disabled={loading_button} onClick={(e) => handleForm(e, 'SameDateTime')}  >
                  {loading_button && clickedButton === 'SameDateTime' ? ( <span className="loader_datepicker_screen"></span> ) : ( `Continue with ${(originalBookingTime.appointmentDate)} at ${originalBookingTime.startTimeReadable}` )}
                </button>
              </div>
              
            </>
          ) : (
            <div className="submit-button-container">
              <button className="custom-button datepicker-continue" disabled={loading_button} onClick={(e) => handleForm(e, 'Default')} >
                {loading_button && clickedButton === 'Default' ? <span className="loader_datepicker_screen"></span> : "Continue"}
              </button>
            </div>
          )}


          {submissionFailed && (
            <div className='error-button-div-datepicker'>
              <img className="error-icon" src={getAssetUrl(errorIcon)} alt="Error Icon" /><p>This appointment time is no longer available. Please select a new date/time</p>
            </div>
          )}
      </div>
  
    );
};

export default DatePickerScreen;
